import React, { useMemo } from "react";
// ANT DESIGN COMPONENTS
import { Tag, Tooltip } from "antd";
// CUSTOM HOOKS
import { useLastLiftMessage } from "../socketMessageState/BankMessagesContext";
// INTERFACES
import { SocketMessageInterface } from "../../../interfaces/Monitoring.interface";
// UTILS
import { getServiceModeDisplay } from "../../../utils/serviceModeDisplay";
import { stringToUuidT } from "../../../utils/uuid";
// CONSTANTS
import { BLANK_SOCKET_MESSAGE } from "../../../constants/monitoring";

export default function MonitoringDeviceLift({
  liftChunk,
}: {
  liftChunk: { id: string; name: string; bank?: string };
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const liftUuid = useMemo(() => stringToUuidT(liftChunk.id), [liftChunk.id]);
  const socketMessageLift: SocketMessageInterface =
    useLastLiftMessage(liftUuid) || BLANK_SOCKET_MESSAGE;

  const serviceModeInfo = useMemo(
    () =>
      getServiceModeDisplay(
        socketMessageLift.serviceMode?.messageType ?? null,
        socketMessageLift.serviceMode?.message?.message ?? null
      ),
    [socketMessageLift.serviceMode]
  );

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const tagColor = serviceModeInfo?.color ?? "gray";
  const displayName = serviceModeInfo?.displayName ?? "--";
  const abbreviation = serviceModeInfo?.abbreviation ?? "--";

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div
      key={liftChunk.id}
      className="generalStyles__flex mt-2  monitoring__device__status__Card__server"
    >
      <div style={{ width: "200px" }}>
        <span style={{ marginLeft: "15px" }}>{liftChunk.name}</span>
      </div>
      <div className=" generalStyles__mrFix" style={{ width: "100px" }}>
        <Tag
          className="generalStyles__textEllipsis"
          style={{ width: "100px", textAlign: "center" }}
          color={tagColor}
        >
          <Tooltip placement="left" title={displayName}>
            {abbreviation}
          </Tooltip>
        </Tag>
      </div>
      <div className=" generalStyles__mrFix" style={{ width: "100px" }}>
        <Tag
          className="generalStyles__textEllipsis"
          style={{ width: "100px", textAlign: "center" }}
          color={tagColor}
        >
          <Tooltip placement="right" title={displayName}>
            {abbreviation}
          </Tooltip>
        </Tag>
      </div>
    </div>
  );
}
